import organizationUserFilters from '@/app/settings/organization/users/filters';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  OrganizationUserConfig,
  type OrganizationUser,
} from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';
import { toReadablePhoneNumber } from '@/lib/phone-number';

export const OrganizationUserItem: RelationFieldProps<OrganizationUser> = {
  nested: getRelationFieldNames(OrganizationUserConfig),
  filters: organizationUserFilters,
  renderItem: (item, isRelationField) => ({
    title: item?.corporateName ?? item?.communicationName,
    avatar: (
      <Avatar className='size-8'>
        <AvatarImage
          className='object-cover'
          src={item?.profilePicture?.get}
          alt={item?.corporateName ?? item?.communicationName}
        />
        <AvatarFallback className='text-xs'>
          {item?.firstName?.[0]}
          {item?.lastName?.[0]}
        </AvatarFallback>
      </Avatar>
    ),
    badge: (
      <span className='text-xs'>
        {item.username ? `@${item.username}` : '-'}
      </span>
    ),
    descriptionItems: (
      <div
        className={cn(
          'flex w-full items-center',
          isRelationField && 'justify-between'
        )}
      >
        <div
          className={cn('truncate font-medium', isRelationField && 'max-w-44')}
        >
          {item.email ?? '-'}
        </div>
        {!isRelationField && <Dot />}
        <span>{toReadablePhoneNumber(item.phoneNumber) ?? '-'}</span>
      </div>
    ),
  }),
};
